import { render, staticRenderFns } from "./Secondary-water-supply.vue?vue&type=template&id=50b71735&scoped=true"
import script from "./Secondary-water-supply.vue?vue&type=script&lang=js"
export * from "./Secondary-water-supply.vue?vue&type=script&lang=js"
import style0 from "./Secondary-water-supply.vue?vue&type=style&index=0&id=50b71735&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b71735",
  null
  
)

export default component.exports